/** Live-map legend swatch line style, mapped 1:1 to a CSS `border-top-style` value. */
export enum TrackingTrailLegendSwatchStyleEnum {
  solid = "solid",
  dashed = "dashed",
  dotted = "dotted",
}
